import MulitpliersSettings from './MulitpliersSettings.component';

export default MulitpliersSettings;
